export default __webpack_public_path__ + "static/media/Cream.866e2e60.png";